var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7749 16.1116C20.4158 17.2225 19.6113 18.6112 18.3313 18.6112H1.66855C0.386017 18.6112 -0.414747 17.2204 0.224906 16.1116L8.55636 1.66619C9.19758 0.554763 10.8036 0.556777 11.4437 1.66619L19.7749 16.1116ZM10 13.125C9.11789 13.125 8.40279 13.8401 8.40279 14.7223C8.40279 15.6044 9.11789 16.3195 10 16.3195C10.8821 16.3195 11.5972 15.6044 11.5972 14.7223C11.5972 13.8401 10.8821 13.125 10 13.125ZM8.48358 7.38386L8.74115 12.1061C8.7532 12.3271 8.93591 12.5 9.15719 12.5H10.8428C11.0641 12.5 11.2468 12.3271 11.2589 12.1061L11.5164 7.38386C11.5295 7.14518 11.3394 6.94449 11.1004 6.94449H8.89959C8.66056 6.94449 8.47056 7.14518 8.48358 7.38386Z",
    fill: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9f5b255fffa091a5df9611c8cc6f44c3.svg";
export { ForwardRef as ReactComponent };